import React from "react";
import "./style.css";

export const Instructions = () => (
    <div className="Instructions">
        <span className="Instructions_Header">Share your photo to Instagram!</span>
        <span className="Instructions_Text">In the caption of your post, answer the question</span>
        <span className="Instructions_Text">&quot;Tell us about a Truly unique summer trip</span>
        <span className="Instructions_Text">you’d like to take with Tru by Hilton.</span>
        <span className="Instructions_Text">Where would you go, with who and why?&quot;</span>
        <span className="Instructions_Text2">Include the hashtag #TRUSUMMER in your caption.</span>
    </div>
);
